import { render, staticRenderFns } from "./UploadWallpaperStepFour.vue?vue&type=template&id=5d130c84&scoped=true&"
import script from "./UploadWallpaperStepFour.vue?vue&type=script&lang=js&"
export * from "./UploadWallpaperStepFour.vue?vue&type=script&lang=js&"
import style0 from "./UploadWallpaperStepFour.vue?vue&type=style&index=0&id=5d130c84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d130c84",
  null
  
)

export default component.exports